import objectResolve from '/src/utils/objectResolve';
// ObjectResolve allow use to resolve deep depencides in an object
import './AreaListData.css';

// Component made to be call in the AreaList, we separate the areaList and the areaListData cause maybe in the future we want some differents functionnaly
const getObjectId = (listChildrens, index)=>{
    if (!listChildrens) return;
    return listChildrens.find(child => child.index === index + 1)?.object_id;// index = 0 ne doit pas etre comptee
}
function AreaListData ({data, ComponentRow, FunctionsRow, componentKey,childrenBlocks}) {
    
    // {...(row.key ? {KeyValue : row.key} : {}) this syntax allow us to defined a property on the object with a ternary condition : if u don't understand check some documentation
    return (
        <div className="area-flex">
                <div className='data-list'>
                    { data && data.map( (row, idx) => <ComponentRow {...row} {...(row.key ? {KeyValue : row.key} : {})} first={idx == 0} idx={idx == data.length - 1 ? - 1 : idx} {...FunctionsRow} key={componentKey ? objectResolve(componentKey, row) : idx} object_block_id={getObjectId(childrenBlocks,idx)}/>)}
                </div>         
        </div>
    )
}

AreaListData.defaultProps = {
    ComponentRow : <div></div>,
    componentKey : '',
    FunctionsRow : {}
}

export default AreaListData;